import { useTranslation } from 'react-i18next';
import { Spinner } from '@/components/ui/spinner';

interface InfinityScrollLoaderProps {
  loadMoreRef: (node: HTMLDivElement | null) => void;
  hasMore?: boolean;
  isLoading?: boolean;
}

export function InfinityScrollLoader({ loadMoreRef, hasMore, isLoading }: InfinityScrollLoaderProps) {
  const { t } = useTranslation();

  if (!hasMore) return null;

  return (
    <div ref={loadMoreRef} className="flex items-center justify-center p-4">
      {isLoading ? (
        <div className="flex items-center gap-2">
          <Spinner className="h-5 w-5" />
          <span className="text-sm text-muted-foreground">{t('common.loading')}</span>
        </div>
      ) : (
        <span className="text-sm text-muted-foreground">{t('common.scrollForMore', 'Scroll for more...')}</span>
      )}
    </div>
  );
}
